import SelectTypeOfDashboard from "../../../components/Table/Dashboard/SelectTypeOfDashboard";
import SingleMonthlyCredits from "../../../components/Table/Dashboard/SingleEntity/SingleMonthlyCredits";
import SingleTotalCreditos from "../../../components/Table/Dashboard/SingleEntity/SingleTotalCreditos";
import { useSingleOrgDashboard } from "../../../context/SuperAdmin/DashboardContexts/SingleOrg";

const SingleOrgDashboard = () => {
  const {
    isLoadingTotalCredits,
    totalCredits,
    isLoadingMonthlyCredits,
    monthlyCredits,
    updateStartingMonth,
    changeMonths,
    months,
    startMonth,
    handleToggleMonthlyCredit,
    monthlyCreditsFilters,
  } = useSingleOrgDashboard();
  return (
    <SelectTypeOfDashboard routeValue="organization">
      <SingleTotalCreditos
        credits={totalCredits[0]}
        isLoading={isLoadingTotalCredits}
      />
      <SingleMonthlyCredits
        isLoading={isLoadingMonthlyCredits}
        monthlyCredits={monthlyCredits}
        startMonth={startMonth}
        months={months}
        changeMonths={changeMonths}
        updateStartingMonth={updateStartingMonth}
        creditsFilters={monthlyCreditsFilters}
        handleToggleCredit={handleToggleMonthlyCredit}
      />
    </SelectTypeOfDashboard>
  );
};

export default SingleOrgDashboard;
